<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="o-form -two-columns">
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>

            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Attributs personnalisés</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Attributs personnalisés</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            >
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom de la catégorie"
                                    label="Nom de la catégorie"
                                    v-model="form.name"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Select
                                    v-model="form.applyTo"
                                    :options="applyToOptions"
                                    :clearable="false"
                                    required
                                    label="Attribut de ..."
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                            <div v-if="form.id" class="full-width">
                                <CustomTags
                                    :embedded="true"
                                    v-bind:parent_id="form.id"
                                    class="q-mt-md q-mb-lg"
                                />
                            </div>

                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { CUSTOMTAGLABELS, APPLYTOMODELS } from '@/graphql/tag/queries'
    import { UPSERTCUSTOMTAGLABEL, DELETECUSTOMTAGLABEL, RESTORECUSTOMTAGLABEL } from '@/graphql/tag/mutations'
    import { removeNULL } from '@/js/utilities'
    import CustomTags from '@/components/settings/CustomTags'

    export default {
        name: 'CustomTagLabels',
        components: {
            CustomTags
        },
        apollo: {
            customTagLabels: {
                query: CUSTOMTAGLABELS,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                        first: this.perPage,
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(customTagLabels) {
                    this.listbox.listItems = Object.assign([], customTagLabels.customTagLabels)
                    return customTagLabels;
                }
            },
            applyToModels: {
                query: APPLYTOMODELS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.applyToOptions=[];
                    data.__type.enumValues.forEach(function(item){
                        this.applyToOptions.push(item.name)
                    }.bind(this))
                    // return data.__type.enumValues
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: false,
                    searchable: 'Rechercher / filtrer'
                },
                form: {},
                applyToOptions: [],
                newItem: {
                    id: 0,
                    name: null,
                    applyTo: 'NONE'
                },
                showDeleted: false,
                perPage: 50,
            }
        },
        mounted: async function(){
            this.setNewItem();
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form = Object.assign({}, this.newItem);

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETECUSTOMTAGLABEL,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.customTagLabels) this.$apollo.queries.customTagLabels.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            saveItem(form) {
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTCUSTOMTAGLABEL,
                    variables: { ...form },
                    update: (store, { data: { upsertCustomTagLabel } }) => {
                        if(!form.id){
                            const data = store.readQuery({ query: CUSTOMTAGLABELS })
                            data.customTagLabels.push(upsertCustomTagLabel);
                            store.writeQuery({
                                query: CUSTOMTAGLABELS,
                                data,
                            })
                        }
                        this.setSelected(upsertCustomTagLabel)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "CustomTag Label : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORECUSTOMTAGLABEL,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { customTagLabel } }) => {
                        if (!form.id) {
                            const data = store.readQuery({ query: CUSTOMTAGLABELS })
                            data.customTagLabels.push(customTagLabel);
                            store.writeQuery({
                                query: CUSTOMTAGLABELS,
                                data,
                            })
                        }
                        this.setSelected(customTagLabel)
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Ressource : " + form.name, caption: "Informations sauvegardées" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
